import React from "react";
import { FaGraduationCap } from "react-icons/fa";

const Education = ({ institution, degree, fieldOfStudy, year }) => {
  return (
    <article className="education-card">
      <div className="education-icon" aria-hidden="true">
        <FaGraduationCap />
      </div>
      <div className="education-details">
        <div className="education-heading">
          <h3>{institution}</h3>
          <span className="education-year">{year}</span>
        </div>
        <p>{degree}, {fieldOfStudy}</p>
      </div>
    </article>
  );
};

export default Education;
